import { HttpHeaders } from '@angular/common/http';

export interface BaseHttpRequest {
  url: string;
}

export interface BaseHttpResponse<T> {
  body?: T | null;
  headers?: HttpHeaders;
  status?: number;
  statusText?: string;
  url?: string;
}
